import { RgbColor } from "@hello-pangea/color-picker";

export class ColorUtils {
    static rgbaStringToRgba(value: string) {
        const match = value.match(/^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*(?:\.\d+)?)\)$/);

        if (!match) {
            throw new Error("Invalid color value");
        }

        const [, r, g, b, a = "1"] = match;

        return {
            r: parseInt(r, 10),
            g: parseInt(g, 10),
            b: parseInt(b, 10),
            a: parseInt(a, 10),
        };
    }

    static rgbStringToRgba(value: string) {
        const match = value.match(/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/);

        if (!match) {
            throw new Error("Invalid color value");
        }

        const [, r, g, b] = match;

        return {
            r: parseInt(r, 10),
            g: parseInt(g, 10),
            b: parseInt(b, 10),
            a: 1,
        };
    }

    public static hexStringToRgba = (hex: string) => {
        const hexValue = hex.replace("#", "");

        const r = parseInt(hexValue.substring(0, 2), 16);
        const g = parseInt(hexValue.substring(2, 4), 16);
        const b = parseInt(hexValue.substring(4, 6), 16);
        const a = parseInt(hexValue.substring(6, 8) || "FF", 16);

        return {
            r,
            g,
            b,
            a: a / 255,
        };
    };

    public static rgbaToString = (rgba: RgbColor) => {
        const { r, g, b, a } = rgba;

        return `rgba(${r},${g},${b},${a})`;
    };

    public static toRgba = (value: string) => {
        if (value.startsWith("#")) {
            return ColorUtils.hexStringToRgba(value);
        }

        if (value.startsWith("rgba")) {
            return ColorUtils.rgbaStringToRgba(value);
        }

        if (value.startsWith("rgb")) {
            return ColorUtils.rgbStringToRgba(value);
        }

        throw new Error(`Unknown color value '${value}'`);
    };
}
